export const GET_REFERRALS_LIST = 'GET_REFERRALS_LIST';
export const SET_REFERRALS_LIST = 'SET_REFERRALS_LIST';
export const SET_REFERRALS_LIST_FAILED = 'SET_REFERRALS_LIST_FAILED';
export const ADD_REFERRAL = 'ADD_REFERRAL';
export const ADD_REFERRAL_SUCCESS = 'ADD_REFERRAL_SUCCESS';
export const ADD_REFERRAL_FAILED = 'ADD_REFERRAL_FAILED';
export const CLEAR_ADD_REFERRAL_SUCCESS = 'CLEAR_ADD_REFERRAL_SUCCESS';
export const GET_REFERRAL_DETAILS = 'GET_REFERRAL_DETAILS';
export const SET_REFERRAL_DETAILS = 'SET_REFERRAL_DETAILS';
export const SET_REFERRAL_DETAILS_FAILED = 'SET_REFERRAL_DETAILS_FAILED';
export const CLEAR_REFERRAL_DETAILS = 'CLEAR_REFERRAL_DETAILS';
export const UPDATE_REFERRAL_STATUS = 'UPDATE_REFERRAL_STATUS';
export const UPDATE_REFERRAL_STATUS_SUCCESS = 'UPDATE_REFERRAL_STATUS_SUCCESS';
export const UPDATE_REFERRAL_STATUS_FAILED = 'UPDATE_REFERRAL_STATUS_FAILED';
export const CLEAR_REFERRAL_STATUS_UPDATE_SUCCESS = 'CLEAR_REFERRAL_STATUS_UPDATE_SUCCESS';
